import LogisticsManagementRoutes from '../pages/LogisticsManagement/routes/LogisticsManagementRoutes';
import BatchCheckpointsRoutes from '../pages/BatchCheckpoints/routes/BatchCheckpointsRoutes';
import AmendmentsRoutes from '../pages/Amendments/routes/AmendmentsRoutes';
import { BusinessExternalOperators } from '../BusinessExternalOperators';
import ShippingsRoutes from '../pages/Shippings/routes/ShippingsRoutes';
import MonitoringRoutes from '../pages/Monitoring/routes/MonitoringRoutes';
import TimeSlotsRoutes from '../pages/TimeSlots/routes/TimeSlotsRoutes';
import CommercesRoutes from '../pages/Commerces/routes/CommercesRoutes';
import ServicesRoutes from '../pages/Services/routes/ServicesRoutes';
import BranchesRoutes from '../pages/Branches/routes/BranchesRoutes';
import DriversRoutes from '../pages/Drivers/routes/DriversRoutes';
import ZonesRoutes from '../pages/Zones/routes/ZonesRoutes';
import JobsRoutes from '../pages/Jobs/routes/JobsRoutes';
import { RouteObject } from 'react-router-dom';

export const BusinessExternalOperatorsRoutes: RouteObject[] = [
  {
    path: '',
    element: <BusinessExternalOperators />,
  },
  ...ShippingsRoutes,
  ...MonitoringRoutes,
  ...JobsRoutes,
  ...DriversRoutes,
  ...LogisticsManagementRoutes,
  ...BatchCheckpointsRoutes,
  ...AmendmentsRoutes,
  ...TimeSlotsRoutes,
  ...ServicesRoutes,
  ...ZonesRoutes,
  ...CommercesRoutes,
  ...BranchesRoutes,
];
